

import React, {useEffect,useState, useReducer} from 'react';
import {Link} from "react-router-dom";

import {_getCoutryGoogleChartName} from '../../helpers/helpers.js'
import TechnologySmallIcon from '../../components/technologySmallIcon.js'

import ScanDomainTechnologies from '../../components/scanTechnologyList.js'
//import ScanDomainCVEs from '../../components/scanCVEList.js'
import SectionHeader from '../../components/sectionHeader.js'
import {_printDate, _printShortFullDate, _printSmallestFullDate, _printNumber} from '../../helpers/helpers.js'
import StartMonitoring from '../../components/startMonitoringButton.js';

import {APIResponse} from '../../../../server/routes/route-types.js'
import {RtHydratedTechnology, RtDomainInfo, RtCVEInfo, RtScanResults, RtSecurityScanResultsPageResult} from '../../../../server/routes/cve-security-scan.js'


// // Interface for CVE data
// interface CVEData {
// 	CVE: string;
// 	Technology: string;
// 	TechnologyIcon: string;
// 	TechnologyURL: string;
// 	Version: string;
// 	Category: string;
// 	CategoryIcon: string;
// 	CategoryURL: string;
// 	DatePublished?: string;
// }

// // Interface for technology data
// interface TechnologyData {
// 	Technology: string;
// 	Category: string;
// 	Icon?: string;
// 	URL?: string;
// }

// // Interface for domain info
// interface DomainInfo {
// 	redirect?: string;
// }

// // Interface for scan results
// interface ScanResults {
// 	status: string;
// 	domainInfo?: DomainInfo;
// 	cves?: CVEData[];
// 	technologies?: TechnologyData[];
// 	error?: string;
// }

// // Interface for page data
// interface CVEFullScanResultsPageData {
// 	Domain: string;
// 	ScanId: string;
// 	CanonicalURL: string;
// 	ScanResults?: ScanResults;
// }

// Interface for component props
interface CVEFullScanResultsProps {
	server: string;
	pageData: unknown;
}

// Interface for scan state
interface ScanState {
	status: string;
	domainInfo: RtDomainInfo | null;
	cves: RtCVEInfo[] | null;
	technologies: RtHydratedTechnology[] | null;
}

// Interface for technology with CVEs
interface TechnologyWithCVEs {
	Technology: string;
	CVEs: RtCVEInfo[];
}

// Interface for component props
interface CVEScanResultProps {
	props: RtSecurityScanResultsPageResult;
}

interface DomainInfoProps {
	domainInfo: RtDomainInfo | null;
}

interface MonitoringCVEListProps {
	techList: TechnologyWithCVEs[];
	link: string;
}

interface CVERowProps {
	technology: TechnologyWithCVEs;
}

interface CVELinkProps {
	CVEId: string;
	i: number;
}

// Type for reducer actions
type ReducerAction = [string, Partial<ScanState>];

export default function ScanResults({server, pageData}: CVEFullScanResultsProps) {

	let [data, setData] = useState(pageData as RtSecurityScanResultsPageResult);

	if (!data.Domain) return  (<></>);
	if (!data.ScanId) return  (<></>);

	if (data.ScanId == 'scan-sample') 
	{
		// Sample Report case
		return (
			<>
				<section className="section section-sm">
					<h3 className="text-left mb-3">
					<b>Sample Website Vulnerability Report</b>
					</h3>
					Website name has been omitted for confidentiality. All vulnerabilities presented were valid at the time of scanning.
					<CVEScanResult  props={data}  /> 
				</section>
	
			</>		
		)
	}

	return (
        <>
             <section className="section section-sm">
				<h3 className="text-left mb-3">
				<b>Website Vulnerability Report</b>
				</h3>
				for website <b>{data.Domain}</b>
				<CVEScanResult  props={data}  /> 
            </section>
   
        </>
    )
}

function CVEScanResult({props}: CVEScanResultProps) {

	if (!props.Domain) return  (<></>);

	const [ scanState, setScanState] = useState<number | boolean>(props.ScanResults && props.ScanResults.status=='completed' ? 0 : 1);
	const [ state, dispatch ] = useReducer( 
		CVEScanFormReducer, getStateFromResults(props.ScanResults));


	// flatten CVE list
	let techMap = new Map<string, {CVEs: RtCVEInfo[]} >;
	let techList: TechnologyWithCVEs[] = [];

	// Technology
	if (!!state.cves && !!state.cves.length) 
	{
		state.cves.map((cve: RtCVEInfo) => {
			if (techMap.has(cve.Technology)) {
				let e = techMap.get(cve.Technology);
				e!.CVEs.push(cve);
				techMap.set(cve.Technology, e!)
			} else {
				techMap.set(cve.Technology, {
					CVEs: [cve]
				});			
			}	
		});		
		techMap.forEach((cve, tech: string) => {
			techList.push(
				{
					Technology: tech, 
					CVEs: cve.CVEs
				});
		})		
	}
		

	useEffect(() => {
		if (scanState) { 
		  const intervalId = setInterval(() => {
			fetchScanResult(props.ScanId);
		  }, 2000); // Refresh every 2 seconds
	
		  return () => clearInterval(intervalId);
		}
	}, [scanState]);	

	function getStateFromResults(results: RtScanResults | undefined): ScanState {
		if (!results) return {			
			status: "Scheduling",
			domainInfo: null,
			cves: null,
			technologies: null
		};

		if (results.status == "running") {					
			return {
				status: 'Scan in progress ',
				domainInfo: null,
				cves: null,
				technologies: null
			}; 
		}
		else if (results.status == "completed") {
			let tech = null;
			let cves = null;

			if (results.cves != null) {	
				cves = results.cves.sort( 
					(a,b) => compareCVEbyTech(a , b));
			}		
			if (results.technologies != null) {	
				tech = results.technologies.sort( 
					(a,b) => compareTechByCategory(a , b));
			}			
			return {
				status: "Completed",
				domainInfo: results.domainInfo!,
				cves: cves,
				technologies: tech
			};  
		} 				
		else if (results.status == "failed") {
			return {
				status: results.error!,
				domainInfo: null,
				cves: null,
				technologies: null
			};  
		} 		
		return {			
			status: 'Failed',
			domainInfo: null,
			cves: null,
			technologies: null
		};
	}
	function processScanResults(results: RtScanResults): void {
		if (!results) return;

		let state: ScanState = getStateFromResults(results);

		if (results.status == "running") {	
			if (typeof scanState === 'number' && scanState > 300) {
				// 10 minute : 600 sec / 2
				setScanState(0);					
				dispatch([ "error", {
					status: "Scan timeout"
				}]); 	
			} else {
				setScanState(typeof scanState === 'number' ? scanState + 1 : 1);					
				state.status += ' ';
				for (let i = 0; i < (typeof scanState === 'number' ? scanState : 0); i++) state.status += '.';
				dispatch([ "success", state]); 	
			}
		}
		else if (results.status == "completed") {
			setScanState(0);
			dispatch([ "success", state]);  
		} 				
		else if (results.status == "failed") {
			setScanState(0);
			dispatch([ "success", state]);  
		} 
	}
	function fetchScanResult (scanId: string): void {
	
	// https://127.0.0.1:3001/cve-security-scan/api-results?scanid=scan-123234234			
	
		fetch( `/cve-security-scan/api-results?scanid=${scanId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
			body: null
		}).then((result: Response) => {
			return result.json();
		}).then((untypedData: unknown) => {

			const data = untypedData as APIResponse<RtScanResults>;

			if (data.err ) { 
				console.log("case 1");
				setScanState(0);	

				if (data.result404 ) { 
					dispatch([ "error", {
						status: data.result404.title
					}]); 
				} else {
					dispatch([ "error", {
						status: data.err
					}]); 
				}
			}
			else if (data.results ) { 
				console.log("case 2");			
				setScanState(typeof scanState === 'number' ? scanState + 1 : 1);	
				processScanResults(data.results);
			} else {
				console.log("case 4");
				setScanState(false);
				dispatch([ "error", {
					status: 'Failed'
				}]); 
			}
		}).catch((e: unknown) => {
			console.error( "Exception", e );
		});
	};   
	
	
	return (
		<>			
			<div className="row row-50">
			<div className="col-12">
				<table className="table-custom table-custom-striped table-custom-primary">
					<tbody>
					<tr>
							<td style={{width: '30%'}}>Security Scan status</td>
							<td style={{width: '70%', color: 'darkgreen'}}>
								<b>{ state.status }</b>
							</td>
						</tr>																
						<tr>
							<td style={{width: '30%'}}>Vulnerable Technologies</td>
							<td style={{width: '70%', color: 'black'}}>
								<b>{ state.cves ? displayVulnCount(techList.length) : '-'}</b>
							</td>
						</tr>																
						<tr>
							<td style={{width: '30%'}}>Detected Vulnerabilities (CVEs)</td>
							<td style={{width: '70%', color: 'black'}}>
								<b>{ state.cves ? displayVulnCount(state.cves.length) : '-'}</b>
							</td>
						</tr>																
						<tr>
							<td style={{width: '30%'}}>Detected Technologies</td>
							<td style={{width: '70%', color: 'black'}}>
								<b>{ state.technologies ? state.technologies.length  : '-'}</b>
							</td>
						</tr>																		
					</tbody>
				</table>
				<DomainInfo domainInfo={state.domainInfo} />			
				{
					props.ScanId != 'scan-sample' && !!state.technologies && !!state.technologies.length  && 
					<StartMonitoring domain={props.Domain} />
				}				
				{
					!!state.cves && !!state.cves.length &&
					<>					
						<MonitoringCVEList techList={techList} link={props.CanonicalURL!} />		
						<br/>
						<br/>			
					</>		
				}

				<br/>
				<br/>
				<br/>
				{
					!!state.technologies && !!state.technologies.length  && 
					<>
					<h3>Detected Technologies</h3>					
						<ScanDomainTechnologies technologies={state.technologies} link={props.CanonicalURL} />
						<br/>
					</>					
				}
			</div>
		</div>		
		</>
		)
}

function displayVulnCount(count: number) {
	if (count) return (<b style={{color: 'darkred'}}>{ count }</b>);

	return (<b style={{color: 'darkgreen'}}>None Detected</b>);
}

function compareCVEbyTech(a: RtCVEInfo | null, b: RtCVEInfo | null): number {
	// workaround null element
    if (a == null || b == null)
        return 0;// a < b;


    if (a.Technology < b.Technology)
        return -1;
    if (a.Technology > b.Technology)
        return 1;
    return 0;
}

function compareCVEbyDate(a: RtCVEInfo | null, b: RtCVEInfo | null): number {
	// workaround null element
    if (a == null || b == null)
        return 0;//a < b;
    if (a.CVE > b.CVE)
        return -1;
    if (a.CVE < b.CVE)
        return 1;
/*
    if (a.DatePublished < b.DatePublished)
        return -1;
    if (a.DatePublished > b.DatePublished)
        return 1;
*/
    return 0;
}


function compareTechByCategory(a: RtHydratedTechnology | null, b: RtHydratedTechnology | null): number {
	// workaround null element
    if (a == null || b == null)
        return 0; //a < b;


    if (a.Category < b.Category)
        return -1;
    if (a.Category > b.Category)
        return 1;
    return 0;
}

const CVEScanFormReducer = function( state: ScanState, [ type, data ]: ReducerAction ): ScanState {
    if( type === "error" ){
		return {
			...state,
			domainInfo: null,
			status: data.status!,
			cves: data.cves!,
			technologies: data.technologies!
		};
	};   
    if( type === "success" ){
		return {
			...state,
			status: data.status!,
			domainInfo: data.domainInfo!,
			cves: data.cves!,
			technologies: data.technologies!
		};;
	};
    return state; 
};

function DomainInfo({domainInfo}: DomainInfoProps) {

	if (!domainInfo) return null;
	if (!domainInfo.redirect) return null;

	return (
		<>
		
		<div className="row row-50">
			<div className="col-12">
				<p style={{color: 'red'}}>
				Website redirects to <b>{domainInfo.redirect}</b>
				</p>
			</div>
		</div>
		</>
	)
}

function MonitoringCVEList({techList, link}: MonitoringCVEListProps) {
	const header = {
		Title: 'Security Issues',
		Subtitle: `List of security issues currently detected on the website`
	};

	if (!techList) return (<></>);
	if (!techList.length) return (
		<>
		<div className="row row-50">
		<div className="col-12">
			<SectionHeader header={header} link={link} anchor='security'/>
			<p>No security issues were found on this website.</p>
		</div>		
		</div>
		</>);

	// CVE, title, tech, version, first detected, last detected
	return (
		<> 			
		<div className="row row-50">
		<div className="col-12">
			<SectionHeader header={header} link={link} anchor='security'/> 
			<div className="table-outer table-rounded table-respoSnsive-lg">
			<table className="table-custom table-custom-striped table-custom-primary  ">
				<thead>
				<tr>
					<th style={{width: '20%'}}>Type</th>
					<th style={{width: '20%'}}>Vulnerable Technology</th>
					<th style={{width: '60%'}}>Security Issues</th>
				</tr>
				</thead>
				<tbody>
			{
				techList.map((technology: TechnologyWithCVEs, indexKey: number) =>
					<CVERow technology={technology} key={indexKey}/>
				)
			}
				</tbody>
			</table>
			</div>
		</div>		
		</div>
		</>
	)
}


function CVERow({technology}: CVERowProps) {
	if (!technology) return (<></>);

	let cves = technology.CVEs.sort((a: RtCVEInfo, b: RtCVEInfo) => compareCVEbyDate(a , b));

	const cve = cves[0];

	// tech (with version), Security issues, first detected, last detected
	return (
		<>
		<tr>   	
			<td>
				<span 
					className={`icon text-primary mdi ${cve.CategoryIcon}`}
				></span> 
				{' '}
				<Link 
					to={`/technology-type/${cve.CategoryURL}`}
					className="link-hover" 
					title={`${cve.Category} category market share and usage statistic`} 
				>
					{cve.Category} 
				</Link>
			</td>		      		
			<td>	  
				<Link 
					to={`/technology/${cve.TechnologyURL}`}
					className="link-hover" 
					title={cve.Technology} 
				>				
					<TechnologySmallIcon 
						technologyIcon={cve.TechnologyIcon} 
						technology={cve.Technology}
					/>
					{' '}{cve.Technology}
				</Link>   
				{' '}{cve.Version}                						
			</td>	
			<td>
				{
					cves.map((cve: RtCVEInfo, i: number) =>
						<CVELink CVEId={cve.CVE} key={i} i={i}/>
					)
				}
			</td>     		      
		</tr>		
		</>
	)
}

function CVELink({CVEId, i}: CVELinkProps) {
	// 6 CVE max (dont have space)
	if (i == 5) return (<>, ...</>);
	if (i >= 6) return (<></>);
	return (
		<>
		{!!i && <>{','}</>}
		{' '}
		<Link 
			to={`/cve/${CVEId}`} 
			className="link-hover" 
		>
			{CVEId}
		</Link> 
		</>
	)
}